import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const EmptystateIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M4.00006 12.9001H10.6667V11.1001H4.00006V12.9001ZM13.3333 12.9001L20 12.9001L20 11.1001H13.3333V12.9001Z"
      />
    </SvgIcon>
  );
});
